export const getNavigationItems = (
  allMainNav: Queries.pageQueryAndPageQueryQuery['allMainNav'],
) => {
  const items = allMainNav?.nodes;
  return items && items.length > 0
    ? items.filter((item) => item.menuAttached)
    : [];
};
